import React from 'react';
import ReactDOM from 'react-dom';
import LoginForm from '../components/LoginForm';

const element = document.getElementById('login-form');

if (element) {
    ReactDOM.render(
        <LoginForm { ...(element.dataset) } />,
        element,
    );
}
